import React, { useContext } from 'react';
import { NativeAPI } from 'src/utils/deviceUtils';
import styles from "./Link.module.scss";
import DeviceContext from 'src/contexts/DeviceContext';

type LinkProps = {
    href: string;
    reftag?: string;
};

export const Link: React.FC<LinkProps> = ({ href, reftag, children }) => {
    const deviceContext = useContext(DeviceContext);
    return (<span className={`${styles.activeText} ${styles[deviceContext.theme]}`} onClick={() => NativeAPI.openWebPage(href, undefined, reftag)} tabIndex={0}>
        {children}
    </span>);
};

